import { type LimitedResponseConfiguration } from '@/shared/lib/datafeed/history-provider';
import { QuotesProvider } from '@/shared/lib/datafeed/quotes-provider';
import { Requester } from '@/shared/lib/datafeed/requester';
import { UDFCompatibleDatafeedBase } from '@/shared/lib/datafeed/udf-compatible-datafeed-base';

export class UDFCompatibleDatafeed extends UDFCompatibleDatafeedBase {
  public constructor(
    datafeedURL: string,
    updateFrequency: number = 10 * 1000,
    limitedServerResponse?: LimitedResponseConfiguration,
  ) {
    const requester = new Requester();
    const quotesProvider = new QuotesProvider(datafeedURL, requester);
    super(datafeedURL, quotesProvider, requester, updateFrequency, limitedServerResponse);
  }
}
